<template>
    <div class="about">
      <TransitionGroup>
        <div class="card mx-auto my-5 shadow" style="min-width: 18rem; max-width: fit-content;overflow: auto;" v-if="showModal">
          <div class="card-body">
            <h5 class="card-title">
               Bank Data
            </h5>
            <button type="button" class="btn-close position-absolute fs-4" aria-label="Close" style="right: 5px;top: 5px;" @click.prevent="showModal=false"></button>
            <div class="contain">
              <p class="card-text text-danger italic">Any changes done here will reflect only invoices generated after the change was applied.</p>
              <div class="row" v-for="r,index in Object.keys(rowData).filter(item=>!formHidden.includes(item))" :key="index">
                <float-select v-if="r=='type'" label="Type" :options="bank_types" v-model="rowData[r]" :disabled="disabled.includes(r)" :ogDataSrc="rowData[r]" listMode="Array"
                                                  label-class="text-dark fw-bold" option-class="bg-primary-subtle bg-gradient" />
                <float-inp v-else-if="!formHidden.includes(r)" type="text" :label="headers[r]" v-model="rowData[r]" class="col-12 px-1 mb-1" :disabled="disabled.includes(r)"
                label-class="text-dark fw-bold" input-class="bg-primary-subtle bg-gradient input" />
              </div>
            </div>
            <a href="#" v-if="rowData['id']===null || rowData['id']<1" class="btn btn-primary" @click.prevent="requestActionCaptcha({ title: 'Confirm Create', promptText: 'Solve the sum to create this bank record.', confirmLabel: 'Create', action: () => postBank('post') })" >Create Bank</a>
            <template v-else>
              <a href="#" class="btn btn-warning me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Duplicate', promptText: 'Solve the sum to duplicate this bank record.', confirmLabel: 'Duplicate', action: () => duplicateCurrentRecord() })" >Duplicate</a>
              <a href="#" class="btn btn-success me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Update', promptText: 'Solve the sum to update this bank record.', confirmLabel: 'Update', action: () => postBank('put') })" >Update Bank</a>
              <button type="button" class="btn btn-outline-danger" @click.prevent="requestActionCaptcha({ title: 'Confirm Delete', promptText: 'Solve the sum to delete this bank record.', confirmLabel: 'Delete', action: () => deleteCurrentRecord() })">
                <i class="bi bi-trash3 me-1"></i>
                Delete
              </button>
            </template>
          </div>
        </div>
        <cdTable :links="links" title="Banks" table-name="banks" :hidden="hidden" :headers="headers" :gen-form="false" v-else @popForm="e=>setRowData(e)" ></cdTable>        
        <ActionCaptchaModal
          :show="showActionCaptcha"
          :title="captchaTitle"
          :prompt-text="captchaPromptText"
          :confirm-label="captchaConfirmLabel"
          @close="closeActionCaptcha"
          @confirmed="confirmActionCaptcha"
        />
        
      </TransitionGroup>

      
    </div>
  </template>
  <script>
  import floatInp from '@/parts/floatInp.vue';
  import floatSelect from '@/parts/floatSelect.vue'
  import cdTable from '@/components/cddatatables/cdTable.vue';
  import ActionCaptchaModal from '@/components/mods/ActionCaptchaModal.vue';
  import { bankLinks } from '@/cd-links';
  export default{
    components:{
      cdTable, floatInp, ActionCaptchaModal, floatSelect
    },
    data(){
      return {
        links: bankLinks,
        headers:{
            id: "ID",
            name: "Bank",
            type: "Type",
            description: "Description",
            shortcode: "Code",
            cog: "Country",
            status: "Status",
            createdAt: "Created On",
            updatedAt: "Updated On"
          },
          hidden:[
            'creatorId',
            /* 'createdAt',
            'updatedAt' */
          ],
          disabled:['id','createdAt','updatedAt'],
          formHidden:[
            'creatorId',
            /* 'createdAt',
            'updatedAt', */
            'status',
            'ent_id'
          ],          
          showModal:false,
          rowData:{
            id: null,
            name: "",
            type: "",
            description: "",
            shortcode: "",
            cog: "",
          },
          preFetch:false,
          loading: false,
          showActionCaptcha: false,
          captchaTitle: 'Confirm Action',
          captchaPromptText: 'Please solve this quick check to continue.',
          captchaConfirmLabel: 'Confirm',
          pendingAction: null,
          bank_types: ['Central Bank', 'Commercial Bank', 'Public Sector Bank', 'Private Sector Bank', 'Foreign Bank', 'Regional Rural Bank (RRB)', 'Co-operative Bank', 'Payment Bank', 'Small Finance Bank']
      }
    },
    methods:{
      requestActionCaptcha({ title, promptText, confirmLabel, action }) {
        this.captchaTitle = title || 'Confirm Action';
        this.captchaPromptText = promptText || 'Please solve this quick check to continue.';
        this.captchaConfirmLabel = confirmLabel || 'Confirm';
        this.pendingAction = typeof action === 'function' ? action : null;
        this.showActionCaptcha = true;
      },
      closeActionCaptcha() {
        this.showActionCaptcha = false;
        this.pendingAction = null;
      },
      confirmActionCaptcha() {
        const action = this.pendingAction;
        this.showActionCaptcha = false;
        this.pendingAction = null;
        if (typeof action === 'function') action();
      },
      duplicateCurrentRecord(){
        const duplicated = JSON.parse(JSON.stringify(this.rowData || {}));
        duplicated.id = null;
        this.rowData = duplicated;
      },
      async deleteCurrentRecord(){
        if (!this.rowData?.id || this.rowData.id < 1) return;

        try {
          const resp = await this.$store.getters.getAxios(this.links.delItem, {
            method: 'delete',
            data: { id: this.rowData.id }
          });

          if (resp.data.isLoggedIn) {
            this.$store.commit('addAlert', {
              title: resp.data.title,
              message: resp.data.msg,
              type: resp.data.success ? 'info' : 'danger'
            });
            if (resp.data.success) this.showModal = false;
          } else {
            this.$store.dispatch('loggedOut');
          }
        } catch (err) {
          this.$store.commit('addAlert', {
            title: 'Error',
            message: err.response?.data?.msg || err.message || 'Error deleting bank',
            type: 'danger'
          });
        }
      },
      async postBank(mode){        
        this.loading=true;
        this.rowData.status=true;
        this.rowData['ent_id']=this.$store.getters.getEntity;
        await this.$store.getters.getAxios(this.links[mode],{method:mode,data:this.rowData})
            .then(resp=>{

              if(resp.data.isLoggedIn){
                this.$store.commit('addAlert', {
                                      title: resp.data.title,
                                      message: resp.data.msg,
                                      type: resp.data.success? 'info' : 'danger'
                                  });
                resp.data.success? this.showModal=false : this.showModal=true;                            
                }
              else this.$store.dispatch('loggedOut');
            })
            // eslint-disable-next-line
            .catch(err=>{
                

            })
      },
      setRowData(e){
        this.rowData=e.rowData;
        this.showModal=true;
      },
    mounted(){
      if(this.$store.getters.getEntity<1){
                this.$store.commit('addAlert', {
                                                    title: "No Entity Selected!",
                                                    message: "Please select an entity to proceed",
                                                    type: 'warning'
                                                })                
                this.$router.push('/');
            }
      else{
        this.preFetch=true;
      }
    }
  }
}
  </script>
  